<div
  class="video-player"
  [ngClass]="{ 'video-player--small': playBtnSize() === 'small' }">
  <!-- video -->
  <video class="video-player__view" [src]="videoPreviewSrc()" #videoElement>
    <source [src]="videoPreviewSrc()" type="video/mp4" />
  </video>

  @if (!hiddenPlayBtn) {
    <div
      class="video-player__btns video-player__btns--play"
      [ngClass]="btnsClass()">
      <!-- play video icon -->
      <div class="btn-outer-ring" (click)="playVideo(videoElement)">
        <div class="btn-middle-ring">
          <div class="btn-circle">
            <i class="btn-icon iconsax" icon-name="play"></i>
          </div>
        </div>
      </div>

      <!-- button text -->
      <span class="btn-text">{{
        playBtnText() | translate | translateData
      }}</span>
    </div>
  } @else {
    <div
      class="video-player__btns video-player__btns--pause"
      [ngClass]="btnsClass()"
      [hidden]="true">
      <!-- pause video icon -->
      <div class="btn-outer-ring" (click)="pauseVideo(videoElement)">
        <div class="btn-middle-ring">
          <div class="btn-circle">
            <i class="btn-icon iconsax" icon-name="pause"></i>
          </div>
        </div>
      </div>

      <!-- button text -->
      <span class="btn-text">{{
        playBtnText() | translate | translateData
      }}</span>
    </div>
  }
</div>
